import { BridgeComponent } from "@hotwired/strada"

export default class extends BridgeComponent {
  static component = "tab-bar"

  connect() {
    super.connect()

    this.onTurboLoad = this.syncTabBarVisibility.bind(this)
    this.onBridgeReady = this.syncTabBarVisibility.bind(this)
    this.onModalShown = this.onModalShown.bind(this)
    this.onModalHidden = this.onModalHidden.bind(this)

    document.addEventListener("turbo:load", this.onTurboLoad)
    document.addEventListener("web-bridge:ready", this.onBridgeReady)
    // Capture: run before any stale handlers that might hide the tab bar on modal open.
    document.addEventListener("shown.bs.modal", this.onModalShown, true)
    document.addEventListener("hidden.bs.modal", this.onModalHidden, true)

    this.syncTabBarVisibility()
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.onTurboLoad)
    document.removeEventListener("web-bridge:ready", this.onBridgeReady)
    document.removeEventListener("shown.bs.modal", this.onModalShown, true)
    document.removeEventListener("hidden.bs.modal", this.onModalHidden, true)
    super.disconnect()
  }

  devisePage() {
    return document.body.dataset.devisePage === "true"
  }

  syncTabBarVisibility() {
    if (!this.enabled) return

    const visible = this.shouldShowTabBar()
    this.send("setVisibility", { visible: visible })
    this.syncBottomInset(visible)
  }

  syncBottomInset(tabBarVisible) {
    if (document.body.dataset.nativeScrollInset === "true") return

    if (tabBarVisible) {
      document.body.style.removeProperty("--turbo-native-tab-bar-inset")
      return
    }

    document.body.style.setProperty("--turbo-native-tab-bar-inset", "0px")
  }

  shouldShowTabBar() {
    if (this.devisePage()) return false

    // Keep the native tab bar visible under Bootstrap modals (empty band = tab bar height).
    return true
  }

  onModalShown() {
    if (!this.enabled || this.devisePage()) return

    this.send("setVisibility", { visible: true })
    this.syncBottomInset(true)
  }

  onModalHidden() {
    this.syncTabBarVisibility()
  }
}
